module.exports = __webpack_public_path__ + "img/11.9c43958e.jpg";